import { Injectable } from '@angular/core';
import { HttpClientService } from '../../../core/services/http/http-client.service';
import { Observable } from 'rxjs';

export interface RegistrationInvitationContext {
    email: string;
    applicationKey: string;
    expiresAt: string | null;
    expired: boolean;
    used: boolean;
    valid: boolean;
    firstName?: string | null;
    lastName?: string | null;
}

@Injectable()
export class RegistrationService {

    constructor(private http: HttpClientService) {
    }

    registration(data: any): Observable<any> {
        return this.http.post(data, '/registration');
    }

    getInvitation(token: string): Observable<RegistrationInvitationContext> {
        return this.http.get<RegistrationInvitationContext>(`/registration-invitation?token=${encodeURIComponent(token)}`);
    }

}
